import { Entity } from './Entity'

export class Asset extends Entity {
	constructor (payload, api) {
		super(Object.assign({}, payload, {type:"asset"}), api);
	}

	/**
	 * Determine asset visibility
	 *
	 * @arg other Another entity
	 *
	 * Assets are visible by those with permission
	 * "driver" and above.
	 *
	 */
	isVisibleBy (other) {
		const acceptablePermissions = [ "driver", "operator", "manager", "admin", "master" ];

		if (super.isVisibleBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}

	/**
	 * Determine if an asset is editable by another entity
	 *
	 * @arg other Another entity
	 *
	 * Assets are editable by those with permissions
	 * "manager", "admin" or "master".
	 *
	 */
	isEditableBy (other) {
		const acceptablePermissions = [ "manager", "admin", "master" ];

		if (super.isEditableBy(other)) {
			if (other.permissions) {
				if (acceptablePermissions.filter( p => other.permissions.includes(p) ).length > 0) {
					return true;
				}
			}
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/JMan/Entity/Asset.js